import { Text } from '@nimbus-ds/components';
import { useTranslationCommon } from 'commons/hooks';
import { AdBar } from './AdBar';

export function PaymentInProcessAdBar() {
  const t = useTranslationCommon('topAdBar.paymentInProcess');
  return (
    <AdBar appearence="warning">
      <Text fontWeight="bold" color="warning-textLow">
        {t('text')}
      </Text>
    </AdBar>
  );
}
